<template>
    <van-nav-bar title="民主评选用户导入界面" style="margin-bottom: 20px" >
    </van-nav-bar>

    <van-row :gutter="[20, 20]">
        <van-col span="12">
            <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :on-success="handleSuccess"
                :show-file-list=false
            >
                &nbsp;&nbsp;&nbsp;<el-button type="primary">点击上传<i class="el-icon-upload el-icon--right"></i></el-button>

                <!-- <div slot="tip" class="el-upload__tip">请上传excel格式文件</div> -->
            </el-upload>
            <el-text class="mx-1" type="primary" size="large">&nbsp;&nbsp;&nbsp;格式如下：</el-text>
            <img src="../images/img.png" height="208" width="912"/>

        </van-col>
        <van-col span="12">
            <el-button type="primary" @click="download">模板下载<i class="el-icon-download el-icon--right"></i></el-button>
        </van-col>

    </van-row>


</template>

<script setup>

import {ref} from "vue";

const uploadUrl = ref(process.env.VUE_APP_API_BASE_URL+"/lj/mzpx/upload");
function handleSuccess(response, file, fileList) {
    // 处理上传成功的逻辑
    console.log(response,file,fileList);
    // 文件上传成功的处理逻辑
    console.log('File uploaded successfully:', response)
    if (response.code === 200) {
        // 成功的状态码处理逻辑
        if (response.success) {
            alert('导入成功');
            console.log('Server responded with success:', response)
        } else {
            alert('导入失败:'+response.message);
            console.error('Server responded with an error:', response.msg)
            // 可以执行错误处理逻辑
        }
    } else {
        alert('上传失败:'+response.msg);
        // 非成功状态码的处理逻辑
        console.error('Server responded with an error status:', response)
    }
}

const download = () => {
    const elemIF = document.createElement('iframe');
    elemIF.src = process.env.VUE_APP_API_BASE_URL + '/lj/mzpx/download';
    elemIF.style.display = 'none';
    document.body.appendChild(elemIF);

    // 如果你想要在文件下载完成后做一些操作，比如移除 iframe，
    // 你可能需要监听 iframe 的 load 事件或者使用其他方式
    // 但请注意，由于跨域或安全限制，这可能并不总是可行的

    // 示例：在 2 秒后移除 iframe（仅用于演示，不是最佳实践）
    setTimeout(() => {
        document.body.removeChild(elemIF);
    }, 2000);
};



</script>

<style scoped>

</style>
